import { EntitySupplier } from "../../entity/EntitySupplier";

export class DtoSuppliersDeleteRes extends EntitySupplier {
  public message: string | null = null;
}
